//refactored MUI Datagrid header with button
// for standard styling across the project
// all MUI Datagrids with a single button will
// use this as a table header
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";

export function CustomTableHeaderWithButton({
  title,
  description,
  buttonText,
  buttonOnClick,
}) {
  return (
    <Grid
      container
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      {/* Title and description for the Datagrid header */}
      <Grid item xs={6}>
        <h2 style={{ paddingLeft: "20px" }}>{title}</h2>
        <p style={{ paddingLeft: "20px" }}>{description}</p>
      </Grid>
      {/* Button for the Datagrid button */}
      <Grid item>
        <Button
          size="small"
          variant="contained"
          sx={{
            padding: "10px 20px",
            mr: "20px",
            m: { xs: "20px" },
            fontSize: "14px",
            backgroundColor: "#c7ab79",
          }}
          onClick={buttonOnClick}
        >
          {buttonText}
        </Button>
      </Grid>
    </Grid>
  );
}
